<template>
  <div class="page" id="app" style="box-sizing: border-box;">
    <img v-if="isMobile == 0" @click="scrollToTop()" class="to_top_img" src="./assets/top.png" />
    <img :class="isMobile == 0 ? '' : 'fy_img_mobile'" class="fy_img" @click="chosLag(2)" v-if="fyType == 1"
      src="./assets/fy1.png" />
    <img :class="isMobile == 0 ? '' : 'fy_img_mobile'" class="fy_img" @click="chosLag(1)" v-else
      src="./assets/fy2.png" />
    <nav class="nav" v-if="isMobile == 0">
      <div class="nav_sp">
        <div class="nav-item">
          <img class="selet_img" src="./assets/selet_img.png" />
          <div class="dropdown">
            <router-link v-if="fyType == 2" to="/brand-story">Brand Story</router-link>
            <router-link v-else to="/brand-story">公司介绍</router-link>
            <router-link v-if="fyType == 2" to="/News">News</router-link>
            <router-link v-else to="/News">新闻</router-link>
            <router-link v-if="fyType == 2" to="/Contact-us">Contact Us</router-link>
            <router-link v-else to="/Contact-us">联系我们</router-link>
          </div>
        </div>
      </div>

      <div class="nav-item" style="position: relative;">
        <div class="nac_ite_sp"></div>
        <router-link to="" v-if="fyType == 2" class="rot_sp">YACHT
        </router-link>
        <router-link to="" v-else class="rot_sp">游艇
        </router-link>
        <div class="dropdown">
          <router-link style="margin-bottom: 15px;" :to="{
            path: `/yacht/${item.id}`,
            query: { t: new Date().getTime() }  // 增加动态时间戳，每次点击不同
          }" v-for="(item, index) in leftTypeList" :key="index">{{ item.translations.name.content }}</router-link>
        </div>
      </div>

      <div class="nav-item" style="position: relative;">
        <div class="nac_ite_sp"></div>
        <router-link to="" v-if="fyType == 2" class="rot_sp">BOAT HOUSE
        </router-link>
        <router-link to="" v-else class="rot_sp">船屋
        </router-link>
        <div class="dropdown">
          <router-link :to="{
            path: `/yacht/${item.id}`,
            query: { t: new Date().getTime() }  // 增加动态时间戳，每次点击不同
          }" v-for="(item, index) in leftTypeList1" :key="index">{{ item.translations.name.content }}</router-link>
        </div>
      </div>

      <router-link to="/">
        <img src="./assets/logofont.png" class="logofont" />
      </router-link>

      <div class="nav-item" style="position: relative;">
        <div class="nac_ite_sp"></div>
        <router-link to="" class="rot_sp">{{
          rightThree[1].translations.name.content }}</router-link>
        <div class="dropdown">
          <router-link :to="{
            path: `/project-one/${rightThree[1].translations.name.content}/${item.translations.name.content}/${item.id}`,
            query: { t: new Date().getTime() }  // 增加动态时间戳，每次点击不同
          }" v-for="(item, index) in rightThreeTwo" :key="index">{{ item.translations.name.content }}</router-link>
        </div>
      </div>
      <div class="nav-item" style="position: relative;">
        <div class="nac_ite_sp"></div>
        <router-link to="" class="rot_sp">{{
          rightThree[2].translations.name.content }}</router-link>
        <div class="dropdown">
          <router-link :to="{
            path: `/project-one/${rightThree[2].translations.name.content}/${item.translations.name.content}/${item.id}`,
            query: { t: new Date().getTime() }  // 增加动态时间戳，每次点击不同
          }" v-for="(item, index) in rightThreeThree" :key="index">{{ item.translations.name.content }}</router-link>
        </div>
      </div>
      <div class="nav-item">
        <router-link to="/projects" v-if="fyType == 2" class="rot_sp">PROJECTS
        </router-link>
        <router-link to="/projects" v-else class="rot_sp">项目
        </router-link>
      </div>
    </nav>






    <nav class="nav_mobile" v-if="isMobile == 1">

      <img @click="leftMoblieLine = !leftMoblieLine" class="to_top_img_mobile" src="./assets//mesg.png" />

      <router-link to="/">
        <img src="./assets/logofont.png" class="logofont_mobile" />
      </router-link>

      <div class="nav_moile_left_line" v-if="leftMoblieLine" @click="leftMoblieLine = !leftMoblieLine">
        <div class="nav_sp" style="margin-bottom: 20px;">
          <div class="nav-item">
            <img class="selet_img" src="./assets/selet_img.png" @click.stop="rightShowWhich = 0" />
            <div class="dropdown" v-if="rightShowWhich == 0" style="margin-left: 140px;top: 0;">
              <router-link style="color: white;opacity: 50%;" v-if="fyType == 2" to="/brand-story">Brand
                Story</router-link>
              <router-link style="color: white;opacity: 50%;" v-else to="/brand-story">公司介绍</router-link>
              <router-link style="color: white;opacity: 50%;" v-if="fyType == 2" to="/News">News</router-link>
              <router-link style="color: white;opacity: 50%;" v-else to="/News">新闻</router-link>
              <router-link style="color: white;opacity: 50%;" v-if="fyType == 2" to="/Contact-us">Contact
                Us</router-link>
              <router-link style="color: white;opacity: 50%;" v-else to="/Contact-us">联系我们</router-link>
            </div>
          </div>
        </div>

        <div class="nav-item" style="position: relative;margin-bottom: 20px;">
          <div class="nac_ite_sp"></div>
          <div style="color: white;opacity: 50%;" v-if="fyType == 2" class="rot_sp" @click.stop="rightShowWhich = 1">
            YACHT
          </div>
          <div style="color: white;opacity: 50%;" v-else class="rot_sp" @click.stop="rightShowWhich = 1">游艇
          </div>
          <div class="dropdown" v-if="rightShowWhich == 1" style="margin-left: 140px;top: 0;">
            <router-link style="margin-bottom: 15px;color: white;opacity: 50%;" :to="{
              path: `/yacht/${item.id}`,
              query: { t: new Date().getTime() }  // 增加动态时间戳，每次点击不同
            }" v-for="(item, index) in leftTypeList" :key="index">{{ item.translations.name.content }}</router-link>
          </div>
        </div>

        <div class="nav-item" style="position: relative;margin-bottom: 20px;">
          <div class="nac_ite_sp"></div>
          <div style="color: white;opacity: 50%;" v-if="fyType == 2" class="rot_sp" @click.stop="rightShowWhich = 2">
            BOAT HOUSE
          </div>
          <div style="color: white;opacity: 50%;" v-else class="rot_sp" @click.stop="rightShowWhich = 2">船屋
          </div>
          <div class="dropdown" v-if="rightShowWhich == 2" style="margin-left: 140px;top: 0;">
            <router-link style="color: white;opacity: 50%;" :to="{
              path: `/yacht/${item.id}`,
              query: { t: new Date().getTime() }  // 增加动态时间戳，每次点击不同
            }" v-for="(item, index) in leftTypeList1" :key="index">{{ item.translations.name.content }}</router-link>
          </div>
        </div>



        <div class="nav-item" style="position: relative;margin-bottom: 20px;">
          <div class="nac_ite_sp"></div>
          <div style="color: white;opacity: 50%;"  class="rot_sp" @click.stop="rightShowWhich = 3">{{
            rightThree[1].translations.name.content }}</div>
          <div class="dropdown" v-if="rightShowWhich == 3" style="margin-left: 140px;top: 0;">
            <router-link style="color: white;opacity: 50%;" :to="{
              path: `/project-one/${rightThree[1].translations.name.content}/${item.translations.name.content}/${item.id}`,
              query: { t: new Date().getTime() }  // 增加动态时间戳，每次点击不同
            }" v-for="(item, index) in rightThreeTwo" :key="index">{{ item.translations.name.content }}</router-link>
          </div>
        </div>

        <div class="nav-item" style="position: relative;margin-bottom: 20px;">
          <div class="nac_ite_sp"></div>
          <div style="color: white;opacity: 50%;" class="rot_sp" @click.stop="rightShowWhich = 4">{{
            rightThree[2].translations.name.content }}</div>
          <div class="dropdown" v-if="rightShowWhich == 4" style="margin-left: 140px;top: 0;">
            <router-link style="color: white;opacity: 50%;" :to="{
              path: `/project-one/${rightThree[2].translations.name.content}/${item.translations.name.content}/${item.id}`,
              query: { t: new Date().getTime() }  // 增加动态时间戳，每次点击不同
            }" v-for="(item, index) in rightThreeThree" :key="index">{{ item.translations.name.content }}</router-link>
          </div>
        </div>


        <div class="nav-item">
          <router-link style="color: white;opacity: 50%;" to="/projects" v-if="fyType == 2" class="rot_sp">PROJECTS
          </router-link>
          <router-link style="color: white;opacity: 50%;" to="/projects" v-else class="rot_sp">项目
          </router-link>
        </div>
      </div>


    </nav>

    <router-view></router-view>

  </div>
</template>

<script>
import { proCategories, proList, getConfig } from '../request/api.js'
import bottom from './components/bottom.vue';

export default {
  components: {
    bottom
  },
  data() {
    return {
      //1是中文  2是英文
      fyType: 2,
      leftTypeList: [],
      leftTypeList1: [],

      //右边三个
      rightThree: [],
      rightThreeOne: [],
      rightThreeTwo: [],
      rightThreeThree: [],

      config: null,

      isMobile: 0,
      leftMoblieLine: false,
      rightShowWhich: 0
    }
  },
  created() {
    // this.getProCategories('zh')
    this.getProCategories('en')
    let langData = { fyType: 2, Lang: 'en' }
    localStorage.setItem('Lang', JSON.stringify(langData));
    // this.getProList()
    getConfig().then(res => {
      localStorage.setItem('config', JSON.stringify(res.data))
      this.config = res.data
    })
    this.judgeDeviceByUA()
  },
  methods: {
    judgeDeviceByUA() {
      //1是手机   0是电脑
      const userAgent = navigator.userAgent.toLowerCase();
      // 匹配常见移动端设备关键词
      const isMobile = /mobile|android|iphone|ipad|ipod|blackberry/i.test(userAgent);
      if (isMobile) {
        this.isMobile = 1
        localStorage.setItem('isMobile', 1)
      } else {
        this.isMobile = 0
        localStorage.setItem('isMobile', 0)
      }
      console.log(this.isMobile)
    },
    scrollToTop() {
      // window.scrollTo 控制页面滚动，behavior: 'smooth' 实现平滑效果
      window.scrollTo({
        top: 0,        // 滚动到顶部（Y轴坐标0）
        left: 0,       // 滚动到左侧（X轴坐标0，适配横向滚动场景）
        behavior: 'smooth'  // 平滑滚动（去掉则为瞬间跳转）
      });
    },
    chosLag(type) {
      this.rightThreeOne = []
      this.rightThreeTwo = []
      this.rightThreeThree = []
      this.fyType = type
      if (this.fyType == 1) {
        let langData = { fyType: 1, Lang: 'zh' }
        localStorage.setItem('Lang', JSON.stringify(langData));
        this.getProCategories('zh')
      } else {
        let langData = { fyType: 2, Lang: 'en' }
        localStorage.setItem('Lang', JSON.stringify(langData));
        this.getProCategories('en')
      }
      window.dispatchEvent(new Event('langChange'));
    },
    //获取顶部右边三个分类
    getProCategories(lag) {
      proList({
        type: 1,
        category_id: 28,
        language: lag
      }).then(res => {
        this.leftTypeList = res.data.data
      })
      proList({
        type: 1,
        category_id: 25,
        language: lag
      }).then(res => {
        this.leftTypeList1 = res.data.data
      })
      proCategories({
        type: 2,
        language: lag
      }).then(res => {
        this.rightThree = res.data
        //遍历获取右边三个下每一个的分类
        for (let i = 3; i < this.rightThree.length; i++) {
          if (this.rightThree[i].parent_id == this.rightThree[0].id) {
            this.rightThreeOne.push(this.rightThree[i])
          }
          if (this.rightThree[i].parent_id == this.rightThree[1].id) {
            this.rightThreeTwo.push(this.rightThree[i])
          }
          if (this.rightThree[i].parent_id == this.rightThree[2].id) {
            this.rightThreeThree.push(this.rightThree[i])
          }
        }
      })
    }
  }
};

</script>

<style>
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  height: 100%;
}

.page {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}

.to_top_img {
  position: fixed;
  right: 40px;
  bottom: 50px;
  width: 50px;
  height: 50px;
  z-index: 9999;
}

.fy_img {
  position: fixed;
  top: 160px;
  right: 40px;
  z-index: 99;
  width: 50px;
  height: 50px;
}

.fy_img_mobile {
  width: 60px;
  height: 60px;
  top: 120px;
  right: 10px;

}

.nav {
  background-color: #6488C6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  padding: 35px 120px 35px;
  box-sizing: border-box;
}

.nav_sp {
  display: flex;
  align-items: center;
  width: 18px;
  justify-content: space-between;
}

a {
  text-decoration: none;
  color: black;
  transition: opacity 0.3s ease, color 0.3s ease, box-shadow 0.3s ease;
}

a:hover {
  opacity: 0.6;
}

.selet_img {
  width: 18px;
  height: 18px;
}

.nav-item {
  position: relative;
}

.nac_ite_sp {
  width: 120px;
  height: 20px;
  position: absolute;
  top: 0;
  left: 0;
}

.rot_sp {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #FFFFFF;
}

.dropdown {
  width: 220px;
  display: block;
  position: absolute;
  background-color: transparent;
  padding: 0;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.logofont {
  width: 220px;
  height: 50px;
}

.nav-item:hover .dropdown {
  opacity: 1;
  pointer-events: auto;
}

.dropdown a {
  display: block;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #042C71;
  /* color: #DCDCDC; */
  text-decoration: none;
  margin: 5px 0;
  opacity: 0.1;
  transform: translateY(-20px);
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.dropdown a:hover {
  color: 042C71;
  box-shadow: none;
  text-decoration: none;
}

.dropdown a:nth-child(1) {
  transition-delay: 0.1s;
}

.dropdown a:nth-child(2) {
  transition-delay: 0.2s;
}

.dropdown a:nth-child(3) {
  transition-delay: 0.3s;
}

.nav-item:hover .dropdown a {
  opacity: 1;
  transform: translateY(0);
}

.nav_mobile {
  position: relative;
  z-index: 99;
  width: 100%;
  height: 15%;
  background: #6488C6;
  font-size: 16px;
  box-sizing: border-box;
}

.to_top_img_mobile {
  position: absolute;
  width: 25px;
  height: 25px;

  z-index: 9;
  bottom: 20%;
  left: 30px;
}

.logofont_mobile {
  position: absolute;
  width: 110px;
  z-index: 9;
  bottom: 20%;
  left: 50%;
  transform: translate(-50%, 0);
  height: 25px;
}

.nav_moile_left_line {
  height: 800px;
  padding-left: 30px;
  padding-top: 140px;
  display: flex;
  flex-direction: column;
  background: linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, #000000 200%);
  position: relative;
  z-index: 999;
}
</style>
